import type { JSX } from 'react';

// eslint-disable-next-line internal-rules/no-restricted-design-system-imports
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { BusinessPagePrefetchedDataProps } from 'src/app/pages/about/business/pageContext';
import { BusinessPageContextProvider, prefetchPageContext } from 'src/app/pages/about/business/pageContext';

import { Layout } from '../layout';

import { BusinessErrorHandler } from './ErrorHandler';

export const Business = withPrefetchedData(
	function Business({ prefetchedData }: BusinessPagePrefetchedDataProps): JSX.Element {
		return (
			<BusinessPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={BusinessErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</BusinessPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,

		prefetchData: async (context) => prefetchPageContext(context),
	},
);
